import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar } from '../../_components/ui/Avatar';

import { useCommunityDisplayName } from '../../_hooks/useCommunityDisplayName';
import { useCommunityLogoUrl } from '../../_hooks/useCommunityLogoUrl';
import { OnboardStepIndicator } from './OnboardStepIndicator';

type OnboardHeaderProps = {
  title?: string;
  subtitle?: string;
  currentStep?: number;
  totalSteps?: number;
};

export const OnboardHeader: FC<OnboardHeaderProps> = ({ title, subtitle, currentStep = 0, totalSteps = 0 }) => {
  const { t } = useTranslation();
  const logoUrl = useCommunityLogoUrl();
  const displayName = useCommunityDisplayName();

  return (
    <header className="flex w-full flex-col items-center gap-6">
      <div className="flex min-w-0 max-w-full items-center justify-center gap-2">
        {logoUrl ? <Avatar src={logoUrl} alt="" className="size-10" /> : null}
        <span className="min-w-0 truncate text-[15px] font-semibold leading-5 tracking-[-0.15px] text-black">
          {displayName}
        </span>
      </div>
      <div className="flex flex-col items-center gap-2 text-center">
        <OnboardStepIndicator currentStep={currentStep} totalSteps={totalSteps} />
        <h1 className="text-xl font-semibold leading-6 tracking-[-0.4px] text-black">
          {title ?? t('community.onboard.title')}
        </h1>
        {subtitle ? <p className="text-[15px] leading-5 tracking-[-0.15px] text-black/50">{subtitle}</p> : null}
      </div>
    </header>
  );
};
